// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_landing_caption = /** @type {(inputs: {}) => string} */ () => {
	return `Discover pain-free walking with Kybun™ technology footwear`
};

const el_landing_caption = /** @type {(inputs: {}) => string} */ () => {
	return `Ανακάλυψε περπάτημα χωρίς πόνο με την τεχνολογία Kybun`
};

const ru_landing_caption = /** @type {(inputs: {}) => string} */ () => {
	return `Откройте безболезненную ходьбу с обувью Kybun™`
};

const he_landing_caption = /** @type {(inputs: {}) => string} */ () => {
	return `גלו הליכה ללא כאב עם נעלי Kybun™‎`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "el" | "ru" | "he" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const landing_caption = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.landing_caption(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("landing_caption", locale)
	if (locale === "en") return en_landing_caption(inputs)
	if (locale === "el") return el_landing_caption(inputs)
	if (locale === "ru") return ru_landing_caption(inputs)
	if (locale === "he") return he_landing_caption(inputs)
	return "landing_caption"
};